<template>
    <div>
        <v-overlay :model-value="loading"
                   class="align-center justify-center">
            <v-progress-circular color="primary"
                                 indeterminate
                                 size="64"></v-progress-circular>

        </v-overlay>
        <div v-if="data" class="pa-2">
            <h2>{{ data.year }}</h2>
            <v-row>
                <v-col cols="3" v-for="group in data.contactGroups" :key="group.groupName">
                    <v-card :color="groupDetails(group.groupName).colour" variant="flat" class="text-center">
                        <v-card-text>
                            <h2 class="mb-1 pb-1 border-b-sm"><v-icon start :icon="groupDetails(group.groupName).icon"></v-icon> {{ group.groupName }}</h2>
                            <div class="header">BUDGET</div>
                            <h2>${{ numberWithCommas(groupBudget(group), 0) }}</h2>
                            <div class="header">ESTIMATE</div>
                            <h2>${{ numberWithCommas(groupEstimate(group), 0) }}</h2>
                            <v-chip size="small" :class="diffClass(groupPercentDiff(group), 0)" class="ml-1 mt-1"><v-icon :icon="groupPercentDiff(group) > 0 ? 'mdi-arrow-up-bold' : groupPercentDiff(group) == 0 ? 'mdi-minus' : 'mdi-arrow-down-bold'" class="mr-1"></v-icon>{{numberWithCommas(groupPercentDiff(group), 0) + '%'}}</v-chip>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="3">
                    <v-card color="blue-grey-darken-1" variant="flat" class="text-center">
                        <v-card-text>
                            <h2 class="mb-1 pb-1 border-b-sm"><v-icon start icon="mdi-equal"></v-icon> Total</h2>
                            <div class="header">BUDGET</div>
                            <h2>${{ numberWithCommas(allGroupBudget, 0) }}</h2>
                            <div class="header">ESTIMATE</div>
                            <h2>${{ numberWithCommas(allGroupEstimate, 0) }}</h2>
                            <v-chip size="small" :class="diffClass(allGroupDiff, 0)" class="ml-1 mt-1"><v-icon :icon="allGroupDiff > 0 ? 'mdi-arrow-up-bold' : allGroupDiff == 0 ? 'mdi-minus' : 'mdi-arrow-down-bold'" class="mr-1"></v-icon>{{numberWithCommas(allGroupDiff, 0) + '%'}}</v-chip>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <div v-for="group in data.contactGroups" :key="group.groupName" class="mb-3 pb-3">
                <v-table density="compact" class="my-2 py-2 border-t-md border-b-md">
                    <tbody>
                        <tr>
                            <td style="width:25%">
                                <v-chip variant="flat" :color="groupDetails(group.groupName).colour" size="large">
                                    <v-icon start :icon="groupDetails(group.groupName).icon"></v-icon> {{ group.groupName }}
                                </v-chip>
                            </td>
                            <td class="text-right" style="width:15%">
                                <small>ACTUAL</small>
                                <h2>{{ numberWithCommas(groupActual(group), 0) }}</h2>
                            </td>
                            <td class="text-right" style="width:15%">
                                <small>ESTIMATE</small>
                                <h2>{{ numberWithCommas(groupEstimate(group), 0) }}</h2>
                            </td>
                            <td class="text-right" style="width:15%">
                                <small>BUDGET</small>
                                <h2>{{ numberWithCommas(groupBudget(group), 0) }}</h2>
                            </td>
                            <td class="text-right" style="width:10%">
                                <small>% DIFF.</small>
                                <h2>{{ groupBudget(group) ? numberWithCommas(groupPercentDiff(group), 0) + '%' : '0' }}</h2>
                            </td>
                        </tr>
                    </tbody>
                </v-table>
                <v-table density="compact">
                    <thead>
                        <tr>
                            <th class="text-left" style="width:25%">
                                Name
                            </th>
                            <th class="text-right" style="width:15%">
                                Actual YTD
                            </th>
                            <th class="text-right" style="width:15%">
                                Actual Estimate
                            </th>
                            <th class="text-right" style="width:15%">
                                Budget {{ data.year }}
                            </th>
                            <th class="text-right" style="width:10%">% Diff.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in group.contacts" :key="item.contact.id">
                            <td><a href="#" @click="openDetails(item)">{{ item.contact.name }}</a><div class="d-block"><v-chip size="x-small" class="pa-1 d-inline" v-if="item.activeBudget.profabilityRating && item.activeBudget.effortRating" :class="ratingClass(item.activeBudget.profabilityRating, item.activeBudget.effortRating)">Rating: {{ item.activeBudget.profabilityRating - item.activeBudget.effortRating }}</v-chip><small class="text-muted ml-2" v-if="item.activeBudget.notes">{{ item.activeBudget.notes }}</small></div></td>
                            <td class="text-right">{{ numberWithCommas(item.activeBudget.ytdActual, 0) }}</td>
                            <td class="text-right">{{ numberWithCommas(item.activeBudget.estimatedActual, 0) }}</td>
                            <td class="text-right"><span v-if="item.activeBudget.budget">{{ numberWithCommas(item.activeBudget.budget, 0) }}</span></td>
                            <td class="text-right" :class="diffClass(item.activeBudget.percentageDifference, item.activeBudget.ytdActual)"><span v-if="item.activeBudget.percentageDifference">{{ numberWithCommas(item.activeBudget.percentageDifference, 0) }}%</span></td>
                        </tr>
                    </tbody>
                </v-table>
            </div>
            <v-dialog v-model="showDetails"
                      persistent
                      :scrim="false">
                <v-card v-if="selectedDetails">
                    <v-toolbar dark
                               color="primary">
                        <v-toolbar-title><v-icon icon="mdi-square-edit-outline"></v-icon> Edit {{ selectedDetails.contact.name }} Budget {{ data.year }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon
                               dark
                               @click="showDetails = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <contact-performance-panel :contact="selectedDetails.contact" :hide-panels="true"></contact-performance-panel>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field :label="data.year+' Budget'"
                                              :disabled="detailSaving"
                                              v-model="editBudget"
                                              :hint="'Enter the customers total budget figure for calendar '+data.year"
                                              persistent-hint></v-text-field>
                                <div class="mb-3">
                                    Budget per month <strong v-if="editBudget && editBudget > 0">${{ numberWithCommas(editBudget/12, 0) }}</strong>
                                </div>
                                <v-textarea :disabled="detailSaving" class="mt-3" rows="6" label="Notes" v-model="editNotes"></v-textarea>
                            </v-col>
                            <v-col cols="8">
                                <v-row class="mb-3">
                                    <v-col cols="3">
                                        <div class="text-caption">Profability Rating (1-5)</div>
                                        <h2 :class="getClass(editProfability, true)">{{ editProfability }}</h2>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-slider show-ticks="always"
                                                  v-model="editProfability"
                                                  :disabled="detailSaving"
                                                  :max="5"
                                                  :min="0"
                                                  :step="1"
                                                  tick-size="2"></v-slider>
                                    </v-col>
                                    <v-col>
                                        <v-card variant="tonal">
                                            <v-card-text class="help-text">
                                                <table class="d-table help-table">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left w-20">Score</th>
                                                            <th class="text-left w-80">Meaning</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="score-col score-1"><strong>5</strong></td>
                                                            <td>Strong margins, fair pricing, minimum charges accepted</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="score-col score-2"><strong>4</strong></td>
                                                            <td>Good margin, occasional price pressure</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="score-col score-3"><strong>3</strong></td>
                                                            <td>OK margin, price sensitive</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="score-col score-4"><strong>2</strong></td>
                                                            <td>Low margin, constant pressure</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="score-col score-5"><strong>1</strong></td>
                                                            <td>Margin erosion / not worth it</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="3">
                                        <div class="text-caption">Effort / Pain Rating (1-5)</div>
                                        <h2 :class="getClass(editEffort, false)">{{ editEffort }}</h2>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-slider show-ticks="always"
                                                  v-model="editEffort"
                                                  :max="5"
                                                  :min="0"
                                                  :step="1"
                                                  :disabled="detailSaving"
                                                  tick-size="2"></v-slider>
                                    </v-col>
                                    <v-col>
                                        <v-card variant="tonal">
                                            <v-card-text class="help-text"> 
                                                <table class="d-table help-table">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left w-20">Score</th>
                                                            <th class="text-left w-80">Meaning</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="score-col score-1"><strong>1</strong></td>
                                                            <td>Easy, predictable, low admin</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="score-col score-2"><strong>2</strong></td>
                                                            <td>Normal effort</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="score-col score-3"><strong>3</strong></td>
                                                            <td>Admin heavy, inconsistent</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="score-col score-4"><strong>4</strong></td>
                                                            <td>Demanding, slow payers, lots of quoting</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="score-col score-5"><strong>5</strong></td>
                                                            <td>Actively painful (chasing, arguing, chaos)</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn :loading="detailSaving"
                               color="success"
                               prepend-icon="mdi-content-save"
                               variant="tonal"
                               @click="saveDetail"
                               dark>
                            SAVE
                        </v-btn>
                        <v-btn dark @click="showDetails = false">
                            CANCEL
                        </v-btn>
                    </v-card-actions>
                    <v-card-text>
                        <div class="history-footer pa-3">
                            <h5 class="pb-2 text-center border-b-sm mb-2">HISTORY</h5>
                            <div v-for="item in selectedDetails.budgets" class="hist-panel text-caption mb-1" :key="item.id">
                                <span class="text-muted"><span v-if="!item.budget && !item.notes && !item.profabilityRating && !item.effortRating">Initial details</span><span v-if="item.budget" class="mr-2"><b>Budget:</b> {{ numberWithCommas(item.budget, 0) }}</span><span v-if="item.notes" class="mr-2"><b>Notes:</b> {{ item.notes }}</span><span v-if="item.profabilityRating" class="mr-2"><b>Profability Rating:</b> {{ item.profabilityRating }}</span><span v-if="item.effortRating" class="mr-2"><b>Effort Rating:</b> {{ item.effortRating }}</span></span>
                                <span class="text-muted"> by <span class="font-weight-bold"><v-icon icon="mdi-account"></v-icon> {{ item.createdBy }}</span> at <span class="font-weight-bold"><v-icon icon="mdi-clock-outline"></v-icon> {{ $dayjs(item.dateUpdated).format("DD/MM/YYYY") }}</span>.</span>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
<style scoped>
    .score-1 {
        color: #27ae60;
    }

    .score-2 {
        color: #2980b9;
    }

    .score-3 {
        color: #f39c12;
    }

    .score-4 {
        color: #e74c3c;
    }

    .score-5 {
        color: #c0392b;
    }
    .help-table tr td, .help-table tr th {
        font-size:10px;
    }
    .help-text {
        line-height: 0.8rem;
        padding: 0.5rem;
    }
    .history-footer {
        background-color: rgb(var(--v-theme-surface));
        margin-top: 20px;
    }
</style>
<script>
    import { numberWithCommas } from "../../mixins/numberMixins";
    function initialState() {
        return {
            loading: false,
            saving: false,
            data: null,
            loaded: false,
            showDetails: false,
            selectedDetails: null,
            editBudget: null,
            editProfability: 0,
            editEffort: 0, 
            editNotes: null,
            detailSaving: false
        };
    }
    export default {
        name: "BudgetReport",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.loadReport();
        },
        props: {
            definition: Object
        },
        components: {
        },
        methods: {
            loadReport(){
                this.errors = null;
                // All good - Run
                this.loading = true;
                let query = [];
                this.$api.get(this.definition.route)
                    .then(res => {
                        this.loading = false;
                        this.data = res.data;
                        this.buildGraphData();
                    }).catch(error => {
                        this.loading = false;
                    });
            },
            getClass(value, reverse) {
                return "score-col score-" + (reverse ? 5 - value : value);
            },
            openDetails(item) {
                this.selectedDetails = item;
                this.editBudget = item.activeBudget.budget || null;
                this.editProfability = item.activeBudget.profabilityRating || 0;
                this.editEffort = item.activeBudget.effortRating || 0;
                this.editNotes = item.activeBudget.notes || null;
                this.showDetails = true;
            },
            saveDetail() {
                this.detailSaving = true;
                const budget = {
                    year: this.data.year,
                    budget: this.editBudget ? parseFloat(this.editBudget) : null,
                    profabilityRating: this.editProfability,
                    effortRating: this.editEffort,
                    notes: this.editNotes
                };
                this.$api.post(`contacts/${this.selectedDetails.contact.id}/budgets`, budget)
                    .then(res => {
                        const contactId = this.selectedDetails.contact.id;
                        for (const group of this.data.contactGroups) {
                            const entry = group.contacts.find(c => c.contact.id === contactId);
                            if (entry) {
                                entry.activeBudget = res.data;
                                break;
                            }
                        }
                        this.showDetails = false;
                        this.detailSaving = false;
                    })
                    .catch(() => {
                        this.detailSaving = false;
                    });
            },
            numberWithCommas,
            groupActual(group) {
                return group.contacts.reduce((sum, c) => sum + (c.activeBudget.ytdActual || 0), 0);
            },
            groupEstimate(group) {
                return group.contacts.reduce((sum, c) => sum + (c.activeBudget.estimatedActual || 0), 0);
            },
            groupBudget(group) {
                return group.contacts.reduce((sum, c) => sum + (c.activeBudget.budget || 0), 0);
            },
            groupPercentDiff(group) {
                const estimate = this.groupEstimate(group);
                const budget = this.groupBudget(group);
                if (!budget) return 0;
                return ((estimate - budget) / budget) * 100;
            },
            groupDetails(groupName) {
                switch (groupName) {
                    case "Managed":
                        return { name: groupName, colour: "indigo-lighten-1", icon: 'mdi-strategy' };
                    case "Standard":
                        return { name: groupName, colour: "blue-grey-lighten-1", icon: 'mdi-clipboard-account' };
                    case "Transactional":
                        return { name: groupName, colour: "brown-lighten-1", icon: 'mdi-invoice-fast-outline' };
                }
            },
            ratingClass(profability, effort) {
                var rating = profability - effort;
                if (rating < -2) {
                    return "text-red-darken-4"
                } else if (rating < 0) {
                    return "text-red-darken-1"
                } else if (rating > 2) {
                    return "text-green-darken-1"
                } else if (rating > 0) {
                    return "text-green-darken-4"
                }
            },
            diffClass(percentage, actual) {
                if (!percentage) {
                    if (actual && actual > 0) {
                        return 'bg-green-lighten-4';
                    }
                    return null;
                }
                if (percentage < 0) {
                    return 'bg-red-lighten-3';
                } else if (percentage > 40) {
                    return 'bg-green-lighten-3';
                }
            }
        },
        computed: {
            allGroupBudget() {
                if (!this.data) return 0;
                return this.data.contactGroups.reduce((sum, group) => sum + this.groupBudget(group), 0);
            },
            allGroupEstimate() {
                if (!this.data) return 0;
                return this.data.contactGroups.reduce((sum, group) => sum + this.groupEstimate(group), 0);
            },
            allGroupDiff() {
                if (!this.allGroupBudget) return 0;
                return ((this.allGroupEstimate - this.allGroupBudget) / this.allGroupBudget) * 100;
            }
        }
    };
</script>